import { Button, Input, Modal } from 'antd'
import React, { useEffect } from 'react'
import { useRoleModel } from '../roleModel'
import { IRoleGroup } from '../RoleTypes'
import { DeleteOutlined, FormOutlined } from '@ant-design/icons';

export function RoleType() {
    const { blockList, choosedBlock, setChoosedBlock, setBlockList, getBlockList, addBlock, updateBlock, insertBlock, deleteBlock } = useRoleModel()
    useEffect(() => {
        getBlockList()
    }, [])

    const handleBlur = () => {
        const {id, name} = choosedBlock as IRoleGroup
        console.log(id,name)
        if(id){//编辑
            const oldName = blockList.find(item => item.id === id)?.name
            // if(name !== oldName){
                updateBlock(choosedBlock)
            // }
            
        }else{
            if(name){
                insertBlock({name})
            }else{
                setChoosedBlock({})
                setBlockList(blockList.filter(i => i.id))
            }
        }
    }

    const deleteOne = (data:IRoleGroup) => {
         Modal.confirm({
            title: '删除',
            centered: true,
            closable: true,
            content: (<div>确定要删除分组--{choosedBlock.name}</div>),
            onOk(){
                deleteBlock(data)
            }
        })
    }

    const editRoleType = (data: IRoleGroup) => {
        setBlockList(blockList.map(i => ({...i, isEdit: i.id === data.id})))
    }

    return (
        <div style={{ flex: 1, height: '100%', overflowY: 'scroll', padding: '0 20px 20px 20px', borderRight: '1px solid #EBEBEB'}}>
            <div className="flex items-center justify-between" style={{ marginBottom: '20px' }}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={addBlock}
                >分组</Button>
            </div>
            {blockList.map((i: any) => {
                if (i.id === choosedBlock.id && i.temporaryId === choosedBlock.temporaryId) {
                    return (
                        <div
                            style={{ height: '42px', backgroundColor: '#F3F6FF', padding: '5px 10px', borderRadius: '4px', margin: '10px 0',fontSize: '15px'}}
                            className="flex items-center"
                            key={i.id || i.temporaryId}
                        >
                            {i.isEdit ? <Input
                                style={{ color: '#4165E3', fontSize: '14px', flex: 1 }}
                                defaultValue={i.name}
                                value = {choosedBlock.name}
                                autoFocus
                                onBlur={(e) => {
                                    handleBlur()
                                }}
                                onChange ={ (e) => {
                                    setChoosedBlock({...choosedBlock, name: e.target.value})
                                }}
                            /> :  <>
                                <span style={{color:"#4165E3", fontSize:"14px", flex: 1}}>{i.name}</span>
                                <FormOutlined style={{ fontSize: '12px', margin: '0 10px', cursor: 'pointer'  }} onClick={() => {editRoleType(i)}}></FormOutlined>
                                <DeleteOutlined  style={{ fontSize: '12px', margin: '0 10px', cursor: 'pointer'  }} onClick={() => {deleteOne(i)}}></DeleteOutlined>
                            </>}
                            
                            
                        </div>
                    )
                } else {
                    return (
                        <div
                            key={i.id || i.temporaryId}
                            style={{ height: '42px', padding: '5px 10px', borderRadius: '4px', margin: '10px 0', cursor: 'pointer' }}
                            onClick={() => {
                                setChoosedBlock(i)
                            }}
                        >
                            {i.name}
                        </div>
                    )
                }
            })}
        </div>
    )
}
